'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _consts = require('../consts');

var _ProviderIntent = require('../components/ProviderIntent');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

var _WixSdkWrapper = require('photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerIntent = function (_Component) {
  (0, _inherits3.default)(BannerIntent, _Component);

  function BannerIntent(props) {
    (0, _classCallCheck3.default)(this, BannerIntent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BannerIntent.__proto__ || (0, _getPrototypeOf2.default)(BannerIntent)).call(this, props));

    _this.state = {
      styleParams: null
    };

    _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.STYLE_PARAMS_CHANGE, function (sp) {
      var styleParams = (0, _assign2.default)({}, sp.numbers, sp.booleans, sp.colors, sp.fonts);
      styleParams.bgColorExpand = styleParams.bgColorExpand || {};
      styleParams.bgColorExpand.value = 'transparent'; // super hack B2C uses the '.shop-background' css class, instead of using transparent
      _this.setState({ styleParams: styleParams });
    });
    return _this;
  }

  (0, _createClass3.default)(BannerIntent, [{
    key: 'onMessageReceived',
    value: function onMessageReceived(type, payload) {
      switch (type) {
        case _providerEvents2.default.setHeight:
          this.props.enableStoreBanner(payload.height && payload.height > 0);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styleParams = this.state.styleParams;

      if (styleParams) {
        return _react2.default.createElement(_ProviderIntent2.default, {
          api: new _WixSDKProviderApi2.default(_WixSdkWrapper2.default),
          intent: _consts.providerIntents.banner,
          connectedProviders: _windowWrapper2.default.connectedProviders,
          additionalParams: { galleryId: _windowWrapper2.default.galleryId },
          onMessageReceived: function onMessageReceived(type, payload, resolve, reject) {
            return _this2.onMessageReceived(type, payload, resolve, reject);
          },
          styleParams: styleParams
        });
      }
      return null;
    }
  }]);
  return BannerIntent;
}(_react.Component);

exports.default = BannerIntent;


BannerIntent.propTypes = {
  enableStoreBanner: _propTypes2.default.func.isRequired
};